/**
 * Real Valanti Labs product screenshots.
 *
 * All files live inside the frontend's public assets directory at
 *   /app/frontend/public/screenshots/
 * and are referenced through root-relative paths so they ship with the
 * production build. Do not reference preview-only asset URLs, signed URLs,
 * or workspace paths from this file — those will not resolve from
 * https://valantilabs.com.
 *
 * IMPORTANT — content inside these screenshots is UNVERIFIED interface content.
 * It includes percentages, "real-time" labels, compliance ticks (GDPR / ISO / CCPA),
 * "on-device processing", "federated learning", performance scores, accuracy figures
 * and other claims that the public website MUST NOT repeat as confirmed claims until
 * each is approved in writing by the Valanti Labs team. Surrounding public copy stays
 * cautious; the screenshots themselves are displayed as illustrative prototype
 * interfaces only.
 *
 * To replace any screenshot in future, drop the new file alongside the others
 * (same filename) — the layouts read from this file and do not need to change.
 */

export const SCREENSHOTS = {
  home: {
    src: '/screenshots/valanti-home.jpeg',
    alt: 'Valanti Labs — home screen (prototype interface).',
  },
  dashboard: {
    src: '/screenshots/val-dashboard.jpeg',
    alt: 'Valanti Labs — performance dashboard (prototype interface).',
  },
  login: {
    src: '/screenshots/login-screen.jpeg',
    alt: 'Valanti Labs — sign-in screen (prototype interface).',
  },
  selectExercise: {
    src: '/screenshots/select-exercise.jpeg',
    alt: 'Valanti Labs — choosing a supported movement (prototype interface).',
  },
  bodyCalibration: {
    src: '/screenshots/body-calibration.jpeg',
    alt: 'Valanti Labs — body calibration screen (prototype interface).',
  },
  privacy1: {
    src: '/screenshots/privacy-data-1.jpeg',
    alt: 'Valanti Labs — privacy and data controls (prototype interface).',
  },
  privacy2: {
    src: '/screenshots/privacy-data-2.jpeg',
    alt: 'Valanti Labs — privacy and data controls continued (prototype interface).',
  },
};

// Hero PhoneMockup on the homepage uses Valanti Home.
export const HERO_SCREENSHOT = SCREENSHOTS.home;

// "Structured feedback" homepage section uses Val Dashboard.
export const FEEDBACK_SCREENSHOT = SCREENSHOTS.dashboard;

// "Inside the app" gallery on /how-it-works.
export const APP_PREVIEW_SET = [
  SCREENSHOTS.login,
  SCREENSHOTS.selectExercise,
  SCREENSHOTS.bodyCalibration,
  SCREENSHOTS.privacy1,
  SCREENSHOTS.privacy2,
];

// Shown beneath any screenshot block on the public site.
export const PROTOTYPE_DISCLAIMER =
  'Prototype interface — illustrative only. Numbers, percentages, scores, status labels and feature names visible inside these screens are unverified interface content and not confirmed Valanti Labs claims.';
